import { Injectable, inject } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { from, Observable } from "rxjs";
import { ISearchHandelssortimentModel } from "~app/features/forsaljning/handelssortiment/handelssortiment.models";
import { MinaHandelssortimentComponent } from "./mina-handelssortiment.component";

@Injectable({
    providedIn: "root"
})
export class MinaHandelssortimentDialogService {
    private readonly ngbModalService = inject(NgbModal);

    openMinaHandelssortimentModal(): Observable<any> {
        const modalRef = this.ngbModalService.open(MinaHandelssortimentComponent, {
            keyboard: false,
            backdrop: "static",
            size: "xl"
        });
        modalRef.componentInstance.isModalActive = true;
        modalRef.componentInstance.saved.subscribe(() => {
            modalRef.close(this.getHandelssortimentsList(modalRef.componentInstance));
        });
        modalRef.componentInstance.closing.subscribe(() => {
            modalRef.close(this.getHandelssortimentsList(modalRef.componentInstance));
        });
        modalRef.componentInstance.closingDirty.subscribe(dirtyMessage => {
            if (dirtyMessage.isSkipSave === true) {
                modalRef.dismiss();
            }
        });
        return from(modalRef.result);
    }

    private getHandelssortimentsList(instance: MinaHandelssortimentComponent): ISearchHandelssortimentModel[] {
        return instance.minaHandelssortimentList.map(x => x.innerModel);
    }

}
